import React from "react";
import PasswordGenerator from "./Components/PasswordGenerator/PasswordGenerator";
import "./App.css";

function App() {
  return (
    <div className="App">
      <div className="content">
        <PasswordGenerator />
      </div>
    </div>
  );
}

export default App;
